import React, { Component } from "react";

// SCSS
import "./ShoveberryLevelLayoutLevelsList.scss";

// Icons & Images
import SunglassesEmoji from "static/assets/shoveberry/images/sunglasses-emoji.png";
import LockEmoji from "static/assets/shoveberry/images/lock-emoji.png";
import CircularBlackCrossIcon from "static/assets/shoveberry/images/circular-black-cross-icon.svg";

class ShoveberryLevelLayoutLevelsList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getLevelDiv(levelNumber) {
    if (this.props.currentLevel > 0) {
      if (this.props.currentLevel > levelNumber) {
        return (
          <div
            className="shoveberry-level-layout-levels-list-component__level-completed"
            key={levelNumber - 1}
          >
            <p className="shoveberry-level-layout-levels-list-component__level-completed--text">
              {levelNumber < 10 ? "0" + levelNumber : levelNumber}
            </p>
            <img
              src={SunglassesEmoji}
              alt="emoji"
              className="shoveberry-level-layout-levels-list-component__level-completed--icon"
            />
          </div>
        );
      } else if (this.props.currentLevel === levelNumber) {
        return (
          <div
            className="shoveberry-level-layout-levels-list-component__level-current"
            key={levelNumber - 1}
          >
            <p className="shoveberry-level-layout-levels-list-component__level-current--text">
              {levelNumber < 10 ? "0" + levelNumber : levelNumber}
            </p>
          </div>
        );
      } else if (this.props.currentLevel < levelNumber) {
        return (
          <div
            className="shoveberry-level-layout-levels-list-component__level-locked"
            key={levelNumber - 1}
          >
            <p className="shoveberry-level-layout-levels-list-component__level-locked--text">
              {levelNumber < 10 ? "0" + levelNumber : levelNumber}
            </p>
            <img
              src={LockEmoji}
              alt="emoji"
              className="shoveberry-level-layout-levels-list-component__level-locked--icon"
            />
          </div>
        );
      }
    }
  }

  render() {
    const { currentLevel, totalLevels, onClose } = this.props;

    let totalLevelsArr = new Array(totalLevels).fill(0);

    return (
      <div className="shoveberry-level-layout-levels-list-component">
        <div className="mobile-only shoveberry-level-layout-levels-list-component__header">
          <img
            src={CircularBlackCrossIcon}
            className="shoveberry-level-layout-levels-list-component__header--back-icon"
            alt="Back icon"
            onClick={onClose}
          />
          <p className="shoveberry-level-layout-levels-list-component__header--text">
            Level Selector
          </p>
        </div>
        <div className="shoveberry-level-layout-levels-list-component__levels-container">
          {totalLevelsArr &&
            totalLevelsArr.length > 0 &&
            totalLevelsArr.map((level, index) => {
              return this.getLevelDiv(index + 1);
            })}
        </div>
      </div>
    );
  }
}
export default ShoveberryLevelLayoutLevelsList;
